export const pains = [
  "Vous passez des heures à préparer chaque cours à partir de zéro, en cherchant des exercices un peu partout.",
  "Vos élèves ne travaillent pas à la maison parce qu'ils ne savent pas quoi ni comment pratiquer.",
  "Chaque élève avance à son rythme et vous avez du mal à garder le fil.",
  "Vous avez l'impression d'improviser le programme, sans progression claire.",
  "Les enfants s'ennuient et abandonnent au bout de quelques mois.",
];

export const audienceYes = [
  "Professeur de piano particulier en quête d'une méthode structurée",
  "Enseignant en école de musique ou en conservatoire",
  "Pianiste qui commence à donner des cours",
  "Professeur avec des élèves de tous âges et de tous niveaux",
];

export const audienceNo = [
  "Ceux qui veulent apprendre le piano seuls",
  "Ceux qui ne sont pas prêts à appliquer un matériel dans leurs cours",
];
